import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import './NotificationsDock.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function NotificationsDock({ onClose, setUnreadCount }) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('session_token');
      const response = await axios.get(`${API}/notifications`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(response.data);
      const unread = response.data.filter(n => !n.read).length;
      setUnreadCount(unread);
    } catch (error) {
      console.error('Failed to fetch notifications');
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      const token = localStorage.getItem('session_token');
      await axios.patch(`${API}/notifications/${notificationId}/read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchNotifications();
    } catch (error) {
      console.error('Failed to mark notification as read');
    }
  };

  const markAllAsRead = async () => {
    try {
      const token = localStorage.getItem('session_token');
      await axios.patch(`${API}/notifications/mark-all-read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchNotifications();
    } catch (error) {
      console.error('Failed to mark all notifications as read');
    }
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="notifications-panel" data-testid="notifications-panel">
      <div className="notifications-header">
        <div>
          <h3>Notifications</h3>
          {unreadCount > 0 && (
            <Button 
              size="sm" 
              variant="ghost"
              onClick={markAllAsRead}
              style={{ marginTop: '0.25rem', fontSize: '0.75rem' }}
            >
              Mark all as read ({unreadCount})
            </Button>
          )}
        </div>
        <button onClick={onClose} className="close-button" data-testid="close-notifications">
          <X size={24} />
        </button>
      </div>
      
      <div className="notifications-list">
        {notifications.length === 0 ? (
          <div className="empty-notifications">
            <p>No notifications</p>
          </div>
        ) : (
          notifications.map(notif => (
            <div 
              key={notif.id} 
              className={`notification-item ${!notif.read ? 'unread' : ''}`}
              data-testid={`notification-${notif.id}`}
            >
              <div className="notification-content">
                <p>{notif.message}</p>
                <span className="notification-time">
                  {new Date(notif.created_at).toLocaleString()}
                </span>
              </div>
              {!notif.read && (
                <Button 
                  size="sm" 
                  variant="ghost" 
                  onClick={() => markAsRead(notif.id)}
                  data-testid={`mark-read-${notif.id}`}
                >
                  <Check size={20} />
                </Button>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
